/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import * as SelectPrimitive from "@radix-ui/react-select";
import type { ComponentRef } from "react";
import * as React from "react";

import { spacing } from "../../../../../global/emotion";
import { ChevronUpIcon } from "../../../_base/icons/Icon/NavigationIcons";

const scrollButtonStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  paddingBottom: spacing.s,
  paddingTop: spacing.s,
};

type SelectScrollUpButtonProps = React.ComponentPropsWithoutRef<
  typeof SelectPrimitive.ScrollUpButton
>;

export const SelectScrollUpButton = React.forwardRef<
  ComponentRef<typeof SelectPrimitive.ScrollUpButton>,
  SelectScrollUpButtonProps
>((props, ref) => (
  <SelectPrimitive.ScrollUpButton ref={ref} css={scrollButtonStyle} {...props}>
    <ChevronUpIcon />
  </SelectPrimitive.ScrollUpButton>
));

SelectScrollUpButton.displayName = "SelectScrollUpButton";
